import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { QUERY_KEYS, HTTP_ENDPOINTS } from "../../../../../../consts/api";

export const useSetupFeesDetail = (params, options = {}) => {
  return useQuery(
    [QUERY_KEYS.setupFeesDetail, params],
    async () => {
      try {
        const res = await http.get(HTTP_ENDPOINTS.getSetupFeesDetail(), {
          params,
        });

        const composeResponse = {
          report: res.data.data.data || [],
          clinics: res.data.data.clinics || [],
          summary: res.data.data.summary || {},
          pagination: res.data.data.pagination || {},
        };

        return composeResponse;
      } catch (error) {
        throw error;
      }
    },
    {
      ...options,
      retry: false, // Don't retry failed requests for now
    },
  );
};
